import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Fa from 'react-fontawesome';
import {
  InputGroup, FormGroup,
  Tooltip, OverlayTrigger,
  Button,
} from 'react-bootstrap';

import styles from './styles.css';

class CustomDateRangeField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start: props.start ? moment(props.start, props.format) : null,
      end: props.end ? moment(props.end, props.format) : null,
      minError: false,
      maxError: false,
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.clearEnd = this.clearEnd.bind(this);
    this.clearStart = this.clearStart.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let shouldValidate = false;
    let nextPropsStart = null;
    let nextPropsEnd = null;

    if (nextProps.start) {
      nextPropsStart = moment(nextProps.start, nextProps.format).startOf('day');
      if (nextPropsStart.isValid() && !nextPropsStart.isSame(this.state.start, 'day')) {
        // this.setState({ start: nextPropsStart });
        shouldValidate = true;
      }
    } else {
      nextPropsStart = this.props.start ? moment(this.props.start, this.props.format).startOf('day') : null;
    }

    if (nextProps.end) {
      nextPropsEnd = moment(nextProps.end, nextProps.format).startOf('day');
      if (nextPropsEnd.isValid() && !nextPropsEnd.isSame(this.state.end, 'day')) {
        // this.setState({ end: nextPropsEnd });
        shouldValidate = true;
      }
    } else {
      nextPropsEnd = this.props.end ? moment(this.props.end, this.props.format).startOf('day') : null;
    }
    this.setState({ start: nextPropsStart, end: nextPropsEnd }, () => {
      if (shouldValidate) {
        this.validate(nextPropsStart, nextPropsEnd, false, false);
      }
    });
  }

  handleStartDateChange(start) {
    this.setState({ start }, () => {
      this.validate(start, this.props.end ? moment(this.props.end, this.props.format) : null, false, true);
    });
  }

  handleEndDateChange(end) {
    this.setState({ end }, () => {
      this.validate(this.props.start ? moment(this.props.start, this.props.format) : null, end, true, true);
    });
  }

  validate(start, end, isEnd = false, shouldUpdate = false) {
    // start & end should be moment instance
    // const { start, end } = this.state;
    const { format } = this.props;
    let valid = false;
    if (start && end) {
      valid = start.isSameOrBefore(end, 'date');
    } else if (!start || !end) {
      valid = true;
    }
    const newState = { minError: false, maxError: false };
    if (!valid) {
      if (isEnd) {
        newState.maxError = true;
      } else {
        newState.minError = true;
      }
    }
    this.setState(newState, () => {
      if (shouldUpdate && valid) {
        this.props.onSelect(start ? start.format(format) : null, end ? end.format(format) : null);
      }
    });
  }


  clearStart() {
    this.handleStartDateChange(null);
  }

  clearEnd() {
    this.handleEndDateChange(null);
  }

  render() {
    const { disabled } = this.props;
    const {
      start, end,
      minError, maxError,
    } = this.state;
    
    let startTip = null;
    let endTip = null;

    if (minError) {
      const tip = (
        <Tooltip id="min-date">
          <div>Start date should be less than end date</div>
        </Tooltip>
      );
      startTip = (
        <InputGroup.Addon>
          <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
            <Fa name="exclamation-triangle" style={{ cursor: 'help' }} className="text-danger" />
          </OverlayTrigger>
        </InputGroup.Addon>
      );
    }

    if (maxError) {
      const tip = (
        <Tooltip id="max-date">
          <div>End date should greater than start date</div>
        </Tooltip>
      );
      endTip = (
        <InputGroup.Addon>
          <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
            <Fa name="exclamation-triangle" style={{ cursor: 'help' }} className="text-danger" />
          </OverlayTrigger>
        </InputGroup.Addon>
      );
    }
    

    return (
      <div>
        <div className="row">
          <div className="col-sm-6">
            <FormGroup style={{ margin: 0 }}>
              <InputGroup className={styles.datePicker}>
                <InputGroup.Addon className="hidden-sm">from</InputGroup.Addon>
                <DatePicker
                  dateFormat="DD MMM YYYY"
                  className="form-control clickable"
                  selected={start}
                  selectsStart
                  startDate={start}
                  endDate={end}
                  maxDate={end}
                  showYearDropdown
                  scrollableYearDropdown
                  placeholderText="start date"
                  onChange={this.handleStartDateChange}
                />
                <InputGroup.Button>
                  <Button bsStyle="link" className={(start !== null ? '' : 'invisible')} disabled={disabled} onClick={this.clearStart}><Fa name="times-circle" /></Button>
                </InputGroup.Button>
                {startTip}
              </InputGroup>
            </FormGroup>
          </div>
          <div className="col-sm-6">
            <FormGroup style={{ margin: 0 }}>
              <InputGroup className={styles.datePicker}>
                <InputGroup.Addon className="hidden-sm">to</InputGroup.Addon>
                <DatePicker
                  dateFormat="DD MMM YYYY"
                  selectsEnd
                  className="form-control clickable"
                  selected={end}
                  startDate={start}
                  endDate={end}
                  minDate={start}
                  showYearDropdown
                  scrollableYearDropdown
                  placeholderText="end date"
                  onChange={this.handleEndDateChange}
                />
                <InputGroup.Button>
                  <Button bsStyle="link" className={(end !== null ? '' : 'invisible')} disabled={disabled} onClick={this.clearEnd}><Fa name="times-circle" /></Button>
                </InputGroup.Button>
                {endTip}
              </InputGroup>
            </FormGroup>
          </div>
        </div>
      </div>
    );
  }
}

CustomDateRangeField.propTypes = {
  start: PropTypes.string,
  end: PropTypes.string,
  onSelect: PropTypes.func,
  format: PropTypes.string,
  disabled: PropTypes.bool,
};
CustomDateRangeField.defaultProps = {
  onSelect: () => {},
  format: 'YYYY-MM-DD',
  end: null,
  start: null,
  disabled: false,
};

export default CustomDateRangeField;
